module.exports = __webpack_public_path__ + "static/img/main-navigation-icon08.7c4e02ad.svg";